import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { CommentBoxComponent } from '@portal-core/tasks/components/comment-box/comment-box.component';
import { TaskAssetModule } from '@portal-core/tasks/components/task-asset/task-asset.module';

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    TaskAssetModule
  ],
  declarations: [
    CommentBoxComponent
  ],
  exports: [
    CommentBoxComponent
  ]
})
export class CommentBoxModule { }
